import { useAppTranslation } from '@hooks/useAppTranslation';
import { H1, Paragraph, YStack } from 'tamagui';

export default function FatalErrorScreen(): React.ReactNode {
  const { t } = useAppTranslation();

  return (
    <YStack
      justifyContent="center"
      alignItems="center"
      flex={1}
      gap={4}
      padding="$4"
    >
      <H1>{t('fatalError.title')}</H1>
      <Paragraph>{t('fatalError.description')}</Paragraph>
    </YStack>
  );
}
